import React from "react";
import { Route, Link, withRouter } from "react-router-dom";
import AddUser from "./user/AddUser";
import FindUser from "./user/FindUser";
import EditUser from "./user/EditUser";
import styled from "styled-components";
import Orders from "./order/Orders";

const AdminWrapper = styled.div`
  padding: 60px;
  h1 {
    text-align: center;
    margin: 30px 60px;
  }
  h3 {
    margin-bottom: 20px;
  }
  .delete {
    padding: 20px;
    font-size: 20px;
    color: white;
    border-radius: 4px;
    background: red;
    margin-top: 30px;
    width: 200px;
  }
  a {
    text-decoration: underline;
    margin-right: 20px;
    font-size: 18px;
    color: ${(props) => props.theme.primaryBlue};
    &:hover {
      color: black;
    }
  }
  hr {
    margin: 50px 0;
  }
`;

const AdminNavigation = (props) => {
  const { allUsers, courses, fetchAllUsers } = props;
  return (
    <AdminWrapper>
      <Link to={`${props.match.url}/addUser`}>Add User</Link>

      <Link to={`${props.match.url}/findUser`}>Find User</Link>

      <Link to={`${props.match.url}/orders`}>Orders</Link>

      <hr />
      <Route
        path={`${props.match.path}/addUser`}
        component={() => (
          <AddUser fetchAllUsers={fetchAllUsers} courses={courses} />
        )}
      />
      <Route
        path={`${props.match.path}/findUser`}
        component={() => <FindUser allUsers={allUsers} />}
      />
      <Route
        path={`/admin/editUser/:userEmail`}
        component={() => (
          <EditUser fetchAllUsers={fetchAllUsers} courses={courses} />
        )}
      />
      <Route path={`/admin/orders`} component={() => <Orders />} />
    </AdminWrapper>
  );
};

export default withRouter(AdminNavigation);
